import { BlogPost, BlogPostResource } from '../../@blog/BlogPost/BlogPost';
import { HorizontalAlignment } from '../../Alignment/Alignment';
import { DefaultBlock, DefaultBlockResource } from '../../Block/Block';

export enum HighlightedBlogPostLayoutResource {
    left = 'Foto links',
    right = 'Foto rechts',
}

export interface HighlightedBlogPostResource extends DefaultBlockResource {
    blog?: BlogPostResource;
    layout?: HighlightedBlogPostLayoutResource;
}

export interface HighlightedBlogPostInterface extends DefaultBlock {
    blogPost?: BlogPost;
    imagePosition?: HorizontalAlignment;
}
